const host = window.location.host
const protocol = (window.location.protocol === 'https:' ? 'https://' : 'http://')
let feedbackHost = protocol + 'aiexchange.test.classba.cn'
let gameHost = protocol + 'game-api.test.classba.cn'
let monitorHost = protocol + 'monitor.test.classba.cn';
let draftHost = '//test-apipool.classba.cn';

switch (host) {
  case 'study.171xue.com':
  case 'study.classba.cn':
    feedbackHost = protocol + 'aiexchange.classba.cn'
    monitorHost = protocol + 'monitor.classba.cn'
    gameHost = protocol + 'game-api.classba.cn'
    draftHost = '//apipool.171xue.com';
    break
  default:
    break
}

export { feedbackHost,monitorHost,gameHost,draftHost }



// WEBPACK FOOTER //
// ./src/api/index.js